import React, { } from 'react';
import { Helmet } from "react-helmet";
import Header from '../../../components/default/header';
import GlobalSidebarMenu from '../../default/header/globalSidebarMenu';
import Breadcrumb from "../../default/breadcrumb/breadcrumb";
import SingleNotificationData from './singleNotificationData';

const SingleNotification = () => {
    

    return (
        <div className="content-wrapper sidebar-menu-enable">
            <Helmet><title>Notification Details</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <GlobalSidebarMenu sidebarTitle="" />
                <div className="content-right">
                    <Breadcrumb />
                    <SingleNotificationData />
                </div>
            </div>
        </div>
    );
};

export default SingleNotification;